module.exports = __webpack_public_path__ + "static/media/tea.370b68db.jpg";